import React from "react";
import Seo from "../components/seo";
import Matrix from "../components/matrix";
import Layout from "../components/layout";
import SectionHead from "../components/newComponents/sectionHead";
import ImgixFluidImage from "../components/newComponents/ImgixFluidImage";
import PlaceHolderImage from "../components/newComponents/placeHolderImage";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import { HandleQuery, StaffEntryData } from "../queries";

export function StaffEntry()
{
    
    let { slug } = useParams();
    const query_state = useQuery(StaffEntryData(slug), {fetchPolicy: 'no-cache'});
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data;
    const { entry } = data; 

  const image = entry[0].featureImage[0];
  const finalImage = image ? <ImgixFluidImage attribution={image.attribution} image={image} sizes="600px" ar={image.width / image.height} focalPoint={image.focalPoint} />  : <PlaceHolderImage />;

  return (
    <Layout>
      <Seo title={entry[0].title} />      
      <div className="main">
        <section className="section-inside">
          <div className="shell">
            <div className="grid sm:grid-cols-12 gap-4">
              <div className="sm:col-span-8"> 
                <SectionHead heading={entry[0].title} date={entry[0].position} email={entry[0].email} linkedin={entry[0].linkedinProfileUrl}/>

                <Matrix blocks={entry[0].bodyContent} />
              </div>
              <div className="sm:col-span-4">{finalImage}</div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};
